import { render, staticRenderFns } from "./RsaPazienteTeleconsultiListPage.vue?vue&type=template&id=d546d8b4"
import script from "./RsaPazienteTeleconsultiListPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteTeleconsultiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports